import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import { HttpError } from "../../components"
import FiscaisForm from "./FiscaisForm"
import * as ApiHelper from "../../ApiHelper"
export default class FiscaisModal extends Component {
  constructor() {
    super()
    this.callBackFiscais = this.callBackFiscais.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getFiscais((fiscais, error) => {
      if (fiscais) {
        this.props.callBack(fiscais)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackFiscais() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <FiscaisForm callBackFiscais={this.callBackFiscais} />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/FiscaisModal.js